"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.C1 = exports.P2_L = exports.P2 = exports.P1 = exports.T4_SB = exports.T4_M = exports.T3 = exports.T2 = exports.T1 = exports.Heading4 = exports.Heading3 = exports.Heading2 = exports.Heading1 = exports.Price = exports.Text = exports.SubHeading = exports.H7 = exports.H6 = exports.H5 = exports.H4 = exports.H3 = exports.H2 = exports.H1 = void 0;
const headingOne_1 = __importDefault(require("./headingOne"));
exports.H1 = headingOne_1.default;
const headingTwo_1 = __importDefault(require("./headingTwo"));
exports.H2 = headingTwo_1.default;
const headingThree_1 = __importDefault(require("./headingThree"));
exports.H3 = headingThree_1.default;
const headingFour_1 = __importDefault(require("./headingFour"));
exports.H4 = headingFour_1.default;
const headingFive_1 = __importDefault(require("./headingFive"));
exports.H5 = headingFive_1.default;
const headingSix_1 = __importDefault(require("./headingSix"));
exports.H6 = headingSix_1.default;
const headingSeven_1 = __importDefault(require("./headingSeven"));
exports.H7 = headingSeven_1.default;
const subHeading_1 = __importDefault(require("./subHeading"));
exports.SubHeading = subHeading_1.default;
const text_1 = __importDefault(require("./text"));
exports.Text = text_1.default;
const priceText_1 = __importDefault(require("./priceText"));
exports.Price = priceText_1.default;
// Headings
const heading_one_1 = __importDefault(require("./headings/heading-one"));
exports.Heading1 = heading_one_1.default;
const heading_two_1 = __importDefault(require("./headings/heading-two"));
exports.Heading2 = heading_two_1.default;
const heading_three_1 = __importDefault(require("./headings/heading-three"));
exports.Heading3 = heading_three_1.default;
const heading_four_1 = __importDefault(require("./headings/heading-four"));
exports.Heading4 = heading_four_1.default;
// Title 
const title_one_1 = __importDefault(require("./titles/title-one"));
exports.T1 = title_one_1.default;
const title_two_1 = __importDefault(require("./titles/title-two"));
exports.T2 = title_two_1.default;
const title_three_1 = __importDefault(require("./titles/title-three"));
exports.T3 = title_three_1.default;
const title_four_1 = __importDefault(require("./titles/title-four"));
exports.T4_M = title_four_1.default;
const title_four_semi_bold_1 = __importDefault(require("./titles/title-four-semi-bold"));
exports.T4_SB = title_four_semi_bold_1.default;
// Paragraph And Caption
const para_one_1 = __importDefault(require("./paragraph-and-caption/para-one"));
exports.P1 = para_one_1.default;
const para_two_1 = __importDefault(require("./paragraph-and-caption/para-two"));
exports.P2 = para_two_1.default;
const para_two_light_1 = __importDefault(require("./paragraph-and-caption/para-two-light"));
exports.P2_L = para_two_light_1.default;
const caption_one_1 = __importDefault(require("./paragraph-and-caption/caption-one"));
exports.C1 = caption_one_1.default;
//# sourceMappingURL=index.js.map